import React from "react";
import { getDate } from "../../../utils/formatDate";
import { BtnSua } from "./ThemmoiSuaGiahanGiaoviec/BtnSua";
import { BtnXoa } from "./Xoa/BtnXoa";
import { BtnGiaHan } from "./ThemmoiSuaGiahanGiaoviec/BtnGiaHan";
import { BtnDanhGia } from "./DanhGia/BtnDanhGia";
import { BtnGiaoViec } from "./ThemmoiSuaGiahanGiaoviec/BtnGiaoViec";
import { BtnChiTiet } from "./ChiTiet/BtnChiTiet";
import { BtnChiTietHopDong } from "./ChiTietKhachHangVaHopDong/BtnChiTietHopDong";

const statusMap = {
    1: { text: "Đang thực hiện",  style: { color: '#00B69B'}},
    3: { text: "Quá hạn", style: { color: '#FF5170' } },
    4: { text: "Kết thúc"},
};
const evaluationMap = {
    0: "Chưa có",
    1: "Hoàn thành",
    2: "Không hoàn thành",
};

const StatusBadge = ({ status, style}) => {
    return <b style={style}>{status}</b>;
};

export const ContentTable = ({ listDanhSach, phanQuyen, onReload, dataSearch }) => {
    if (!listDanhSach || listDanhSach.length === 0) {
        return (
            <div className="custom-table-row no-data" style={{ minHeight: 56, justifyContent: 'center' }}>
                <p>Không có dữ liệu</p>
            </div>
        );
    }
    const pageStartIndex = (dataSearch.pageIndex - 1) * dataSearch.pageSize;
    
    const getButtonStates = (task) => {
        const defaultStates = { canEdit: false, canDelete: false, canExtend: false, canEvaluate: false, canReassign: false };
        if (!task) return defaultStates;

        const status = task.StatusCode;
        const evaluation = task.EvaluationCode;

        if (status === 3) return { ...defaultStates, canEdit: true, canDelete: true, canExtend: true, canEvaluate: true }; // Quá hạn
        if (status === 1) return { ...defaultStates, canEdit: true, canDelete: true, canEvaluate: true }; // Đang thực hiện
        if (status === 4) { // Kết thúc
            if (evaluation === 1) return { ...defaultStates, canDelete: true }; // Hoàn thành
            if (evaluation === 2) return { ...defaultStates, canDelete: true, canReassign: true }; // Không hoàn thành
        }
        return defaultStates;
    };

    return (
        <>
            {listDanhSach.map((item, index) => {
                const buttonStates = getButtonStates(item);
                const statusInfo = statusMap[item.StatusCode] || { text: "Không xác định", style: {} };
                const evaluationText = evaluationMap[item.EvaluationCode] || "Chưa có";
                
                return (
                    <div
                        key={item.Id}
                        className="custom-table-row"
                        style={{ minHeight: "56px", borderBottom: '1px solid #e0e0e0' }}
                    >
                        <div className="custom-table-cell flex-basis-5 flex-basis-5-sm">
                            <span className="mobile-column-name color7-bold">STT</span>
                            <div className="center-wrapper word-break text-center" style={{justifyContent: 'center'}}>
                                {pageStartIndex + index + 1}
                            </div>
                        </div>
                        <div className="custom-table-cell text-left flex-basis-12 flex-basis-12-sm">
                            <span className="mobile-column-name color7-bold">Mã công việc</span>
                            <div className="center-wrapper word-break">
                                <BtnChiTiet item={item} /> 
                            </div>
                        </div>
                        <div className="custom-table-cell text-left flex-basis-13 flex-basis-13-sm">
                            <span className="mobile-column-name color7-bold">Nhân viên</span>
                            <div className="center-wrapper word-break">
                                {item.AssignedToName}
                            </div>
                        </div>
                        <div className="custom-table-cell text-left flex-basis-15 flex-basis-15-sm">
                            <span className="mobile-column-name color7-bold">Tên công việc</span>
                            <div className="center-wrapper word-break">
                                {item.Title}
                            </div>
                        </div>
                        <div className="custom-table-cell text-left flex-basis-15 flex-basis-15-sm">
                            <span className="mobile-column-name color7-bold">Liên quan đến HĐ</span>
                            <div className="center-wrapper word-break">
                                <BtnChiTietHopDong item={item} />
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
                            <span className="mobile-column-name color7-bold">Thời hạn</span>
                            <div className="center-wrapper word-break text-center" style={{justifyContent: 'center', flexDirection: 'column'}}>
                                {getDate(item.StartDate)}
                                {item.StartDate && item.EndDate && <br />}
                                {getDate(item.EndDate)}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
                            <span className="mobile-column-name color7-bold">Trạng thái</span>
                            <div className="center-wrapper word-break text-center" style={{justifyContent: 'center'}}>
                                <StatusBadge status={statusInfo.text} style={statusInfo.style} />
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
                            <span className="mobile-column-name color7-bold">Đánh giá</span>
                            <div className="center-wrapper word-break text-center" style={{justifyContent: 'center'}}>
                                {evaluationText}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
                            <div className="center-wrapper" style={{ display: 'flex', gap: '5px', justifyContent: 'center', alignItems: 'center' }}>
                                {phanQuyen.quanlycongviec_suacongviec && buttonStates.canEdit && <BtnSua item={item} onReload={onReload} />}
                                {phanQuyen.quanlycongviec_xoacongviec && buttonStates.canDelete && <BtnXoa item={item} onReload={onReload} />}
                                {phanQuyen.quanlycongviec_giahan && buttonStates.canExtend && <BtnGiaHan item={item} onReload={onReload} />}
                                {phanQuyen.quanlycongviec_danhgia && buttonStates.canEvaluate && <BtnDanhGia item={item} onReload={onReload} />}
                                {phanQuyen.quanlycongviec_giaochonguoikhac && buttonStates.canReassign && <BtnGiaoViec item={item} onReload={onReload} />}
                            </div>
                        </div>
                    </div>
                );
            })}
        </>
    );
};